export default __webpack_public_path__ + "025b72d0609cf954ac7ccb7a53db4d17.svg";